import {Link} from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import {useTranslation} from "react-i18next";
import {
    PtElement,
    PtRouteTypeElement,
    WalkElement
} from "../../../api/entities/replancity_RoadInfrastructureRoute";


const RouteSegmentCard = (props: PtRouteTypeElement) => {
    const {t} = useTranslation();

    if ((props as PtElement).fromStop) {
        const {
            mode,
            departureTime,
            travelTime,
            boardingTime,
            fromStop,
            toStop,
            routeName,
        } = props as PtElement;

        return (
            <Tooltip title={t('route-check.road-segment-card-tooltip')} placement="right">
                {/*<Link to={`../roads/${roadId}/${id}/edit`}>*/}
                <div className="segment-card">
                    <div className="segment-card__line">Mode: {mode}</div>
                    <div className="segment-card__line segment-card__properties">
                        <span>Route name: {routeName}</span>
                        <span>From stop: {fromStop}</span>
                        <span>To stop: {toStop}</span>
                        <span>Departure time: {departureTime},</span>
                        <span>Travel time: {travelTime},</span>
                        <span>Boarding time: {boardingTime}</span>
                    </div>
                </div>
                {/*</Link>*/}
            </Tooltip>
        )
    }

    const {
        mode,
        departureTime,
        travelTime,
        distance
    } = props as WalkElement

    return (
        <Tooltip title={t('route-check.road-segment-card-tooltip')} placement="right">
            {/*<Link to={`../roads/${roadId}/${id}/edit`}>*/}
            <div className="segment-card">
                <div className="segment-card__line">Mode: {mode}</div>
                <div className="segment-card__line segment-card__properties">
                    <span>Distance: {distance}</span>
                    <span>Departure time: {departureTime},</span>
                    <span>Travel time: {travelTime},</span>
                </div>
            </div>
            {/*</Link>*/}
        </Tooltip>
    )
}

export default RouteSegmentCard;